import * as React from 'react';
import { toast, Loader } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { validationErrorLabelMap } from '../../utils/get-validation-error-codes.js';
import { EmptyCartContainer } from '../EmptyCart/containers/EmptyCartContainer.js';
import { Cart as Cart$1 } from './components/Cart.js';
import { useCart } from '../../context/Cart/context.js';
import { useCartSettings } from '../../context/CartSettings/context.js';

const Cart = ({ onEmptyCartButtonClick , policyItems  })=>{
    const { cart , loading , error  } = useCart();
    const settings = useCartSettings();
    const intl = useIntl();
    const cartExists = Boolean(cart);
    const labels = React.useMemo(()=>({
            cartTitle: intl.getLabel('cart.title'),
            unavailableTitle: intl.getLabel('cart.unavailableItems.title')
        })
    , [
        intl
    ]);
    React.useEffect(()=>{
        if (cart === null || cart === void 0 ? void 0 : cart.validationErrors) {
            const errorCodes1 = Object.entries(cart.validationErrors).flatMap(([, errorCodes])=>{
                return errorCodes.map((code)=>validationErrorLabelMap[code]
                );
            });
            new Set(errorCodes1).forEach((code)=>{
                toast.failed(`cart.${code}`);
            });
        }
    }, [
        cart === null || cart === void 0 ? void 0 : cart.validationErrors
    ]);
    if (loading) {
        return /*#__PURE__*/ React.createElement("div", {
            className: "cart",
            "data-t": "loading-cart"
        }, /*#__PURE__*/ React.createElement(Loader, null));
    }
    const lineItems = (cart === null || cart === void 0 ? void 0 : cart.lineItems.filter((lineItem)=>{
        var ref;
        return !(cart === null || cart === void 0 ? void 0 : (ref = cart.validationErrors) === null || ref === void 0 ? void 0 : ref[lineItem.id]);
    })) || [];
    const unavailableLineItems = (cart === null || cart === void 0 ? void 0 : cart.lineItems.filter((lineItem)=>{
        var ref;
        return cart === null || cart === void 0 ? void 0 : (ref = cart.validationErrors) === null || ref === void 0 ? void 0 : ref[lineItem.id];
    })) || [];
    const cartEmpty = lineItems.length < 1 && unavailableLineItems.length < 1;
    const deliveryResolver = settings.deliveryResolverFactory && settings.deliveryResolverFactory(lineItems);
    const visualLineItems = (cart === null || cart === void 0 ? void 0 : cart.visualLineItems) || [];
    const availableVisualLineItems = visualLineItems.filter((visualLineItem)=>{
        return lineItems.some((lineItem)=>lineItem.id === visualLineItem.id
        );
    });
    if (!cartExists || error || cartEmpty) {
        return /*#__PURE__*/ React.createElement(EmptyCartContainer, {
            onClick: onEmptyCartButtonClick
        });
    }
    return cart ? /*#__PURE__*/ React.createElement(Cart$1, {
        labels: labels,
        lineItems: lineItems,
        visualLineItems: availableVisualLineItems,
        unavailableLineItems: unavailableLineItems,
        readOnly: settings.readOnly,
        deliveryResolver: deliveryResolver,
        policyItems: policyItems
    }) : null;
};

export { Cart };
//# sourceMappingURL=Cart.js.map
